import {SidebarSuggestedWorkflows as Component} from '@github-ui/code-view-sidebar/components/SidebarSuggestedWorkflows'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarSuggestedWorkflowsResponse} from '@github-ui/code-view-sidebar/types'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarSuggestedWorkflows(props: Props) {
  return isCombinedSidebarPayloadEnabled() ? (
    <SidebarSuggestedWorkflowsCombined {...props} />
  ) : (
    <SidebarSuggestedWorkflowsIndividual {...props} />
  )
}

function SidebarSuggestedWorkflowsCombined({ownerLogin, repoName}: Props) {
  const {suggestedWorkflows} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!suggestedWorkflows) return null
  return <Component {...suggestedWorkflows} />
}

function SidebarSuggestedWorkflowsIndividual({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'suggestedWorkflows', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/suggested-workflows`)
      if (!r.ok) throw new Error(`Sidebar suggested-workflows fetch failed (${r.status})`)
      return (await r.json()) as SidebarSuggestedWorkflowsResponse
    },
  })

  if (!data) return null
  return <Component {...data} />
}
